//@flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { Default } from '../../components/Responsive';
import { PartnersH4 } from './PartnersStyles';
import { CustomFilterWrapperMobile } from './ReferredPartnersIndex/ReferredPartnersIndexStyles';
import ReferredPartnerFilters from './ReferredPartnerFilters';
import {
  downloadCsv,
  toggleCalendarFilter,
  clearCalendarFilter,
  setCalendarStartFilter,
  setCalendarEndFilter,
  setCalendarSaga,
  setSearchFilter
} from './ReferredPartnersIndex/reducer';

type Props = {
  location: Location,
  viewportDevice: string,
  searchValue: string,
  setSearchFilter: () => void,
  toggleCalendarFilter: () => void,
  calendarFilterState: boolean,
  calendarStart: moment,
  calendarEnd: moment,
  clearCalendarFilter: () => void,
  setCalendarStartFilter: () => void,
  setCalendarEndFilter: () => void,
  setCalendarSaga: () => void,
  downloadCsv: string => void
};

class FilterBlock extends Component<Props> {
  handleCsv = () => {
    this.props.downloadCsv('referral_details');
  };
  render() {
    const filterEnabled = this.props.location.pathname === '/partners/referred';
    return (
      <>
        <Default>
          <PartnersH4>Referred Partners</PartnersH4>
        </Default>
        <CustomFilterWrapperMobile
          title={'Referred Partners'}
          downloadCsv={this.handleCsv}
          disabled={!filterEnabled}
        >
          <ReferredPartnerFilters
            searchValue={this.props.searchValue}
            setSearchFilter={this.props.setSearchFilter}
            toggleCalendarFilter={this.props.toggleCalendarFilter}
            calendarFilterState={this.props.calendarFilterState}
            calendarStart={this.props.calendarStart}
            calendarEnd={this.props.calendarEnd}
            clearCalendarFilter={this.props.clearCalendarFilter}
            setCalendarStartFilter={this.props.setCalendarStartFilter}
            setCalendarEndFilter={this.props.setCalendarEndFilter}
            windowSize={this.props.viewportDevice}
            setCalendarSaga={this.props.setCalendarSaga}
            disabled={!filterEnabled}
            downloadCsv={this.handleCsv}
          />
        </CustomFilterWrapperMobile>
      </>
    );
  }
}

const mapStateToProps = state => ({
  searchValue: state.partners.referredPartners.index.searchValue,
  calendarFilterState:
    state.partners.referredPartners.index.calendarFilterState,
  calendarStart: state.partners.referredPartners.index.calendarStart,
  calendarEnd: state.partners.referredPartners.index.calendarEnd,
  viewportDevice: state.global.viewportDevice
});

const mapDispatchToProps = {
  setSearchFilter,
  downloadCsv,
  toggleCalendarFilter,
  clearCalendarFilter,
  setCalendarStartFilter,
  setCalendarEndFilter,
  setCalendarSaga
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FilterBlock)
);
